/**
 * Lo poco que la pantalla recuerda entre visitas: hoy, el idioma.
 *
 * Sale de `sesion.ts` porque la pagina publica de alta tambien tiene selector de
 * idioma y no tiene sesion ninguna --no hay usuario que elegir-- y porque
 * `sesion.ts` arrastra el diccionario del cotizador, que en la pagina publica no
 * pinta nada [frontend/perfil.mjs].
 *
 * Las claves llevan prefijo del modulo: en un Codespace o en un despliegue con
 * varias herramientas bajo el mismo dominio, `idioma` a secas se pisaria con el
 * de otra.
 */

import { esIdioma, IDIOMA_POR_DEFECTO, type Idioma } from './traductor';

const CLAVE_IDIOMA = 'freight-bridge.idioma';

/** localStorage puede lanzar --modo privado, almacenamiento lleno, iframe con
 *  cookies bloqueadas-- y perder la preferencia de idioma no puede tumbar la
 *  pantalla. */
export function leer(clave: string): string | null {
  try {
    return window.localStorage.getItem(clave);
  } catch {
    return null;
  }
}

export function escribir(clave: string, valor: string | null): void {
  try {
    if (valor === null) window.localStorage.removeItem(clave);
    else window.localStorage.setItem(clave, valor);
  } catch {
    /* sin persistencia: la sesion sigue, solo no se recuerda. */
  }
}

/** [CLAUDE.md, Idioma] "seleccion persistida en el cliente, español por
 *  defecto". */
export function idiomaGuardado(): Idioma {
  const v = leer(CLAVE_IDIOMA);
  return esIdioma(v) ? v : IDIOMA_POR_DEFECTO;
}

export function guardarIdioma(idioma: Idioma): void {
  escribir(CLAVE_IDIOMA, idioma);
}
